import { Box, Container } from '@mui/material';

import { AppPage } from '@/shared/components';
import { useDocumentTitle } from '@/shared/hooks/useDocumentTitle';
import ApiKeyManagementComponent from '@/features/apiKey/components/ApiKeyManagement';
import PageHeader from '@/shared/components/PageHeader';

const ApiKeyManagementPage = () => {
  const title = 'Clip Export Api Key';

  useDocumentTitle(title);

  return (
    <AppPage title={title} requiredPermissions={['menu:api']}>
      <Container maxWidth="xl" sx={{ marginTop: 4, marginBottom: 4 }}>
        <PageHeader title={title} subtitle="Clip export API key allows you to export your clips." />
        <Box sx={{ marginTop: 4 }}>
        <ApiKeyManagementComponent />
        </Box>
      </Container>
    </AppPage>
  );
};

export default ApiKeyManagementPage;
